/** VersionComparison — side-by-side proposal version diff. */
import { XCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function VersionComparison({ versions, currentId, onClose }) {
  const nav = useNavigate();
  if (!versions?.length) return null;
  return (
    <section className="bg-card border border-border/60 overflow-auto" data-testid="proposal-versions-panel">
      <div className="flex items-center px-4 h-10 border-b border-border/60">
        <div className="label-cap">Proposal Version History — Side-by-side</div>
        <button className="btn-ghost ml-auto !px-1" onClick={onClose} aria-label="Close version history"><XCircle size={14}/></button>
      </div>
      <table className="w-full text-xs">
        <thead className="text-[10px] uppercase tracking-widest text-muted-foreground bg-background/20">
          <tr>
            <th className="text-left px-3 py-1.5 font-normal">Ver</th>
            <th className="text-left px-3 py-1.5 font-normal">Created</th>
            <th className="text-right px-3 py-1.5 font-normal">Market</th>
            <th className="text-left px-3 py-1.5 font-normal">Rec</th>
            <th className="text-right px-3 py-1.5 font-normal">B Entry</th>
            <th className="text-right px-3 py-1.5 font-normal">B Stop</th>
            <th className="text-right px-3 py-1.5 font-normal">B Target</th>
            <th className="text-right px-3 py-1.5 font-normal">B R/R</th>
            <th className="text-left px-3 py-1.5 font-normal">Status</th>
            <th className="text-right px-3 py-1.5 font-normal"></th>
          </tr>
        </thead>
        <tbody>
          {versions.map((v) => {
            const planB = (v.analyst?.plans || []).find((p) => p.id === "B") || {};
            const isCurrent = v.id === currentId;
            return (
              <tr key={v.id} className={`border-t border-border/40 ${isCurrent ? "bg-secondary/40" : ""}`}>
                <td className="px-3 py-2 mono">v{v.version}</td>
                <td className="px-3 py-2 mono text-muted-foreground">{new Date(v.created_at).toLocaleString()}</td>
                <td className="px-3 py-2 mono text-right">${v.market_snapshot?.price?.toFixed?.(2)}</td>
                <td className="px-3 py-2 mono">{v.consensus?.recommended_plan_id || "—"}</td>
                <td className="px-3 py-2 mono text-right">${planB.entry?.toFixed?.(2) || "—"}</td>
                <td className="px-3 py-2 mono text-right pnl-down">${planB.stop?.toFixed?.(2) || "—"}</td>
                <td className="px-3 py-2 mono text-right pnl-up">${planB.targets?.[0]?.price?.toFixed?.(2) || "—"}</td>
                <td className="px-3 py-2 mono text-right">{planB.reward_risk?.toFixed?.(2) || "—"}</td>
                <td className="px-3 py-2 mono uppercase text-[10px]">{v.status}</td>
                <td className="px-3 py-2 text-right">
                  {!isCurrent && (
                    <button className="btn-ghost h-6 !px-2 text-[10px]" onClick={() => nav(`/proposal/${v.id}`)} data-testid={`proposal-open-v${v.version}`}>
                      Open
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </section>
  );
}
